import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import analytics from '../../../modules/analytics';
import {
  BodyText,
} from '../../ui';
import { StarIconFilled, ChevronIcon } from '../../ui/Icons';
import Button from '../../ui/Button';
import useMount from '../../../hooks/useMount';

type AchieveGoalsBannerProps = {
  /** provider ID */
  providerId: number | string;
};

const AchieveGoalsBanner: React.FC<AchieveGoalsBannerProps> = ({ providerId }) => {
  useMount(() => {
    analytics.track('pro_goals_how_to_viewed');
  });

  return (
    <Button
      testID="monthly-goal-banner-achieve-goals"
      appearance="none"
      link="provider.growth_tab.goals"
      linkParams={{ providerId }}
      clickTracking="pro_goals_how_to_clicked"
    >
      <Inline
        alignItems="center"
      >
        <StarIconFilled />
        <Box
          paddingLeft={12}
          minHeight={44}
          justifyContent="center"
          alignItems="center"
        >
          <BodyText
            appearance="normal"
            weight="bold"
            textAlign="left"
            textTransform="none"
          >
            How to achieve this month&apos;s goal
          </BodyText>
        </Box>
        <ChevronIcon
          direction="right"
          color={colors.smudge}
          style={{
            marginLeft: 'auto',
          }}
        />
      </Inline>
    </Button>
  );
};

export default AchieveGoalsBanner;
